import styled, { css, keyframes } from 'styled-components';

export const LoaderRoot = styled.div<{ fadeIn?: boolean }>`
  position: relative;
  height: 70vh;

  ${props =>
    props.fadeIn &&
    css`
      opacity: 0;
      animation: ${keyframes`
        0% { opacity: 0; }
        50% { opacity: 0 }
        100%   { opacity: 1; }
      `} 0.8s;
      animation-fill-mode: forwards;
    `};
`;
